import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../components/Common/Card';
import Input from '../../components/Common/Input';
import Select from '../../components/Common/Select';
import Textarea from '../../components/Common/Textarea';
import Button from '../../components/Common/Button';
import api from '../../utils/api';
import { showSuccess, showError } from '../../utils/swal';
import { ArrowLeft } from 'lucide-react';

const MeetingForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const isEditMode = !!id;
  const [customers, setCustomers] = useState([]);

  const [formData, setFormData] = useState({
    customer_id: '',
    date: '',
    type: 'face_to_face',
  });

  useEffect(() => {
    fetchCustomers();
    if (isEditMode) {
      fetchMeeting();
    }
  }, [id]);

  const fetchCustomers = async () => {
    try {
      const response = await api.get('/customers');
      setCustomers(response.data.data || response.data);
    } catch (error) {
      console.error('Müşteriler yüklenemedi:', error);
    }
  };

  const fetchMeeting = async () => {
    try {
      const response = await api.get(`/meetings/${id}`);
      const meeting = response.data;

      // Format date for datetime-local input (YYYY-MM-DDTHH:mm)
      let formattedDate = '';
      if (meeting.date) {
        const date = new Date(meeting.date);
        formattedDate = date.toISOString().slice(0, 16);
      }

      if (meeting.is_completed) {
        navigate(`/meetings/${id}/complete`);
        return;
      }

      setFormData({
        customer_id: meeting.customer_id || '',
        date: formattedDate,
        type: meeting.type || 'face_to_face',
      });
    } catch (error) {
      console.error('Görüşme yüklenemedi:', error);
      showError('Görüşme yüklenemedi');
      navigate('/meetings');
    }
  };

  const handleChange = (e) => {
    const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;
    setFormData({
      ...formData,
      [e.target.name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (isEditMode) {
        await api.put(`/meetings/${id}`, formData);
        showSuccess('Görüşme başarıyla güncellendi');
      } else {
        await api.post('/meetings', formData);
        showSuccess('Görüşme başarıyla eklendi');
      }
      navigate('/meetings');
    } catch (error) {
      console.error('Görüşme eklenirken hata:', error);
      const errorMessage = error.response?.data?.message || error.response?.data?.errors || 'Görüşme kaydedilirken bir hata oluştu';
      showError(typeof errorMessage === 'object' ? JSON.stringify(errorMessage) : errorMessage);
      setLoading(false);
    }
  };

  return (
    <div>
      <div className="mb-6">
        <Button variant="secondary" size="sm" onClick={() => navigate('/meetings')}>
          <ArrowLeft size={16} />
          Geri
        </Button>
      </div>

      <form onSubmit={handleSubmit}>
        <Card title="Görüşme Bilgileri" className="mb-6">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Select
              label="Müşteri"
              name="customer_id"
              value={formData.customer_id}
              onChange={handleChange}
              options={customers.map(c => ({
                value: c.id,
                label: `${c.name} ${c.surname}`
              }))}
              required
            />
            <Input
              label="Görüşme Tarihi"
              name="date"
              type="datetime-local"
              value={formData.date}
              onChange={handleChange}
              required
            />
            <Select
              label="Görüşme Tipi"
              name="type"
              value={formData.type}
              onChange={handleChange}
              options={[
                { value: 'face_to_face', label: 'Yüz Yüze' },
                { value: 'call', label: 'Arama' },
                { value: 'email', label: 'E-posta' },
                { value: 'whatsapp', label: 'WhatsApp' },
                { value: 'other', label: 'Diğer' },
              ]}
              required
            />
          </div>
        </Card>

        <div className="flex gap-3 justify-end">
          <Button
            type="button"
            variant="secondary"
            onClick={() => navigate('/meetings')}
          >
            İptal
          </Button>
          <Button type="submit" disabled={loading}>
            {loading ? 'Kaydediliyor...' : isEditMode ? 'Görüşmeyi Güncelle' : 'Görüşmeyi Kaydet'}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default MeetingForm;
